<script>
import VueQr from "vue-qr";
import printJS from "print-js";

export default {
  name: "PrintView",
  components: {VueQr},


  data() {
    return {
      printInfo: {
        visitorName: "",
        visitorCount: "",
        visitorCompany: "",
        visitorPhone: "",
        visitorReason: "",
        visitorCarNo: "",
        visitorCountry: "",
        visitorCardNo: "",
        enterArea: "",
        employeeDepartment: "",
        employeeName: "",
        enterTime: "",
        leaveTime: "",
        employeeSign: "",
        guardSign: "",
        qrCode: "",
        qrCodeImage: "",
        isProvider: false,
        saveArea: "",
      },
      timeNow: "11月11日11时11分",
    }
  },

  watch: {
    'printInfo.qrCode'(val) {
      if (val) {
        setTimeout(() => {
          this.printInfo.qrCodeImage = this.$refs.qrCode.$el.src;
        }, 100);
      } else {
        this.printInfo.qrCodeImage = ""
      }
    },
  },


  methods: {
    setPrintInfo(printInfo) {
      this.printInfo.visitorName = printInfo.visitorName;
      this.printInfo.visitorCount = printInfo.visitorCount;
      if(printInfo.visitorCompany && printInfo.visitorCompany.length > 9) {
        this.printInfo.visitorCompany = printInfo.visitorCompany.substring(0, 8) + "...";
      } else {
        this.printInfo.visitorCompany = printInfo.visitorCompany;
      }
      this.printInfo.visitorCardNo = printInfo.visitorCardNo;
      // this.printInfo.visitorPhone = printInfo.visitorPhone;  脱敏展示
      let showPhone = printInfo.visitorPhone
      if (printInfo.visitorPhone.length >= 11) {
        showPhone = printInfo.visitorPhone.substring(0, 3) + "****" + printInfo.visitorPhone.substring(7);
      }
      this.printInfo.visitorPhone = showPhone;
      this.printInfo.visitorReason = printInfo.visitorReason;
      this.printInfo.visitorCarNo = printInfo.visitorCarNo;
      this.printInfo.visitorCountry = printInfo.visitorCountry;
      this.printInfo.enterArea = printInfo.enterArea;
      if (printInfo.employeeDepartment && printInfo.employeeDepartment.length > 9) {
        this.printInfo.employeeDepartment = printInfo.employeeDepartment.substring(0, 8) + "...";
      } else {
        this.printInfo.employeeDepartment = printInfo.employeeDepartment;
      }
      this.printInfo.employeeName = printInfo.employeeName;
      this.printInfo.enterTime = printInfo.enterTime;
      this.printInfo.leaveTime = printInfo.leaveTime;
      this.printInfo.employeeSign = printInfo.employeeSign;
      this.printInfo.guardSign = printInfo.guardSign;
      this.printInfo.qrCode = printInfo.qrCode;
      this.printInfo.isProvider = printInfo.isProvider;
      this.printInfo.saveArea = printInfo.saveArea;

    },

    startPrint() {
      // this.timeNow : xx月 xx日 xx时 xx分
      let time = new Date();
      this.timeNow =
          (time.getMonth() + 1).toString().padStart(2, '0') +
          time.getDate().toString().padStart(2, '0') +
          time.getHours().toString().padStart(2, '0') +
          time.getMinutes().toString().padStart(2, '0');
      this.$nextTick(() => {
        this.privateDoPrint()
      })
    },

    privateDoPrint() {
      console.log("doPrint", this.printInfo)
      document.querySelector("#content-to-print").style.display = "block";
      printJS({
        printable: 'content-to-print', // 需要打印的元素的 ID
        type: 'html', // 打印内容类型
        targetStyles: ['*', 'table', 'td'],  // 可选：包括所有样式
        style: `
@media print {
  #content-to-print {
    margin: 4mm; /* 设置页边距 */
    font-family: Arial, sans-serif;
    font-size: 20px;
    color: #333;
  }
  @page {
    size: A6;
    margin: 4mm; /* 设置页面边距 */
  }


.header {
  border: 1px solid #000;
  padding: 5px 0;
  text-align: center;
  line-height: 1.5;
  width: 20%;
  font-size: 16px;
}

.message {
  border: 1px solid #000;
  padding: 5px 0;
  text-align: center;
  line-height: 1.5;
  width: 30%;
  font-size: 14px
}

.message2 {
  border: 1px solid #000;
  padding: 5px;
  text-align: left;
  line-height: 1.5;
  width: 30%;
  font-size: 14px
}
.font-8 {
  font-size: 8px;
}

}
        `
      });
      document.querySelector("#content-to-print").style.display = "none";

    },
  }
}
</script>

<template>
  <div class="print-area">
    <VueQr ref="qrCode" class="top-right-qr" draggable="false" :correctLevel="3" :dotScale="1" v-show="false" :size="256" :text="printInfo.qrCode"/>
    <div id="content-to-print" style="display: none " class="a6">
      <div ref="print-info" style="height: 100%;line-height: 1.2; margin: 0 auto;">
        <div style="display: flex; flex-direction: row; justify-content: space-between ">
          <div style="font-size: 12px">正面</div>
          <div style="font-size: 10px">{{ timeNow }}</div>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: center; align-items: center; height: 32px">
          <div style="font-size: 16px">访 客 单</div>
        </div>
        <table style="width: 98% ;font-size: 10px; line-height: 1.5">
          <tr>
            <td class="header">访客姓名</td>
            <td class="message">{{ printInfo.visitorName }}</td>
            <td class="header">来访人数</td>
            <td class="message">{{ printInfo.visitorCount }}</td>
          </tr>
          <tr>
            <td class="header">来访单位</td>
            <td class="message">{{ printInfo.visitorCompany }}</td>
            <td class="header">{{ printInfo.isProvider ? "访客卡号" : "访客手机" }}</td>
            <td class="message">{{ printInfo.isProvider ? printInfo.visitorCardNo : printInfo.visitorPhone }}</td>
          </tr>
          <tr>
            <td class="header">来访事由</td>
            <td class="message">{{ printInfo.visitorReason }}</td>
            <td class="header">车牌号码</td>
            <td class="message">{{ printInfo.visitorCarNo }}</td>
          </tr>
          <tr>
            <td class="header">存放区域</td>
            <td class="message2" colspan="3">{{ printInfo.saveArea }}</td>
          </tr>
          <tr>
            <td class="header">被访部门</td>
            <td class="message">{{ printInfo.employeeDepartment }}</td>
            <td class="header">被访人员</td>
            <td class="message">{{ printInfo.employeeName }}</td>
          </tr>
          <tr>
            <td class="header">进入时间</td>
            <td class="message">{{ printInfo.enterTime }}</td>
            <td class="header">离开时间</td>
            <td class="message">{{ printInfo.leaveTime }}</td>
          </tr>
          <tr>
            <td class="header">被访者签名</td>
            <td class="message">{{ printInfo.employeeSign }}</td>
            <td class="header">保安签名</td>
            <td class="message">{{ printInfo.guardSign }}</td>
          </tr>
        </table>
        <div style="width: 98%; border: black solid 1px ; text-align: center; padding: 2px; border-top-width:  0;">
          <img v-if="printInfo.qrCode" style="margin: auto" width="120px" height="120px" :src="printInfo.qrCodeImage" alt="QR Code"/>
        </div>
        <div style="width: 98%; padding: 2px; border: black solid 1px;  border-top-width:  0;font-size: 8px">
          <p class="font-8"><b>本人承诺:</b></p>
          <p class="font-8">本人于上海华虹宏力半导体制造有限公司访问、施工、公务期间:</p>
          <p class="font-8">1、将严格遵守贵司的保密制度，对于接触到的任何信息、资料、技术文件等承担保密义务。</p>
          <p class="font-8">2、将严格遵守贵司的各项规章制度，承诺不擅自携带、夹带贵司的资材出厂。如违反前述义务，本人同意承担民事或刑事责任，并赔偿贵司因此所遭受的所有经济损失。</p>
          <p class="font-8">3、是否了解华虹宏力公司安全健康环境政策？</p>
          <p class="font-8"><span style="margin-left: 30px;">是□</span> <span style="margin-left: 30px;">否□</span></p>
          <p class="font-8">4、访客可能接触到的重要环境因素，被访人需提前告诉。</p>
          <p class="font-8">环境职业健康安全方针：严格遵守安全健康环保法规，致力于清洁生产，持续改善，为员工营造出安全健康舒适的工作环境，不懈追求“零灾害”和永续经营的最高目标，成为模范世界公民。</p>
        </div>
        <div style="width: 98%; padding: 2px;border: black solid 1px;  border-top-width:  0;font-size: 8px">
          <p class="font-8">本公司承诺：</p>
          <p class="font-8">1、本公司将按照国家相关法律、法规的要求，保护访客信息安全，除法律、法规要求披露的情况外，不向任何第三方披露公司存档的访客信息。</p>
          <p class="font-8">2、访客信息仅限于访客登记确认使用，根据体系管理要求，访客信息保存两年，两年后按体系管理要求进行销毁。</p>
          <p class="font-8">3、如需删除本人信息，请联系021-38829909-67429。</p>
          <p class="font-8">4、请妥善保管访客单及访客证，离开时交还门卫。</p>
          <br>
          <div style="display: flex; justify-content: center; padding: 16px">
            <div style="width: 200px" class="font-8">我已充分知晓和理解承诺内容，签名确认：</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>


.a6 {
  width: 105mm;
  height: 140mm;
}


.header {
  border: 1px solid #000;
  padding: 2px 0;
  text-align: center;
  line-height: 1.2;
  width: 20%;
  font-size: 14px;
}

.message {
  border: 1px solid #000;
  padding: 2px 0;
  text-align: center;
  line-height: 1.2;
  width: 30%;
  font-size: 12px
}

.message2 {
  border: 1px solid #000;
  padding: 5px;
  text-align: left;
  line-height: 1.2;
  width: 30%;
  font-size: 12px
}

.font-8 {
  font-size: 8px;
}

</style>
